const type = 'SET_PAYMENT_AMOUNT_SLIDER';

const setPaymentAmountSlider = (data) => ({
  data,
  type,
});

export { type };
export default setPaymentAmountSlider;
